import { AiFillHome } from 'react-icons/ai'
import { BsPersonFill } from 'react-icons/bs'
import { MdHomeRepairService } from 'react-icons/md'
import { AiFillAppstore } from 'react-icons/ai'
import { AiFillMessage } from 'react-icons/ai'
import { FaBriefcase } from 'react-icons/fa'
import { IoSchoolSharp } from 'react-icons/io5'

const data = [
    { id: 1, link: '#header', icon: <AiFillHome /> },
    { id: 2, link: '#about', icon: <BsPersonFill /> },
    { id: 3, link: '#services', icon: <MdHomeRepairService /> },
    { id: 4, link: '#portfolio', icon: <AiFillAppstore /> },
    { id: 5, link: '#contact', icon: <AiFillMessage /> },
    //{ id: 6, link: '#careers', icon: <FaBriefcase /> },
    //{ id: 7, link: '/virtual-internship/data-science', icon: <IoSchoolSharp /> }
]

export default data